import { stableStringify } from '../checklist/ChecklistSnapshotCreationService';

/** O snapshot legado sem idioma corresponde ao padrão pt-BR do backend. */
export const matchesHistoricalArchive = (
  table: string, local: Record<string, unknown>, remote: Record<string, unknown>,
): boolean => {
  const snapshot = table === 'guincho_checklist_snapshots';
  if (snapshot && (local.locale ?? 'pt-BR') !== (remote.locale ?? 'pt-BR')) return false;
  return Object.keys(remote).every(key => {
    if (snapshot && key === 'locale') return true;
    // Conteúdo, hash e demais metadados continuam imutáveis, inclusive colunas desconhecidas.
    return stableStringify(local[key] ?? null) === stableStringify(remote[key] ?? null);
  });
};
